








































import Vue from 'vue'

export default Vue.extend({
  name: 'Pill',
  props: {
    pillText: {
      type: String,
      required: false,
      default: null
    }
  }
})
